import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getStudentIdData } from "../../../lib/studentbooklistview";
import { deleteIdData, addData } from "../../../lib/studentbooklist";
import { useAuth } from "../../../usercontext";
import STopMenu from "../../../components/student/topmenu/topmenu";
import S911TopMenu from "../../student911/topmenu/topmenu";
import PageNotes from '../../pages/common/pagenotesnew'
// eslint-disable-next-line react/prop-types
export default function StudentBookList() {
	const [booklist, setBookList] = useState([])
	const { profile } = useAuth()

	//const slug = "6cd022a6-81d9-4aba-8487-fd34f1ffd4c9";
	const slug = profile.id

	async function UpdateIsRead(Id, isRead, bookId) {
		if (isRead !== null) isRead = true
		else isRead = false

		//Id doesnt exist you have to add
		if (Id === null) {
			console.log('Add', Id, isRead, bookId)
			await addData({
				isRead: !isRead,
				studentId: slug,
				bookId: bookId
			})
		} else {
			console.log('Update', Id, isRead, bookId)
			await deleteIdData(Id)
			/*
        await updateData({
          id: parseInt(Id),
          isRead : !isRead
        });
        */
		}
		GetData()
	}

	function ChangeStatus(Id, isRead, bookId) {
		//console.log("Id",Id,isRead);
		/*
    const myNextList = [...booklist];
    const artwork = myNextList.find(
      a => a.id === Id
    );
    artwork.isRead = !artwork.isRead;
    console.log("myNextList",myNextList);
    setBookList(myNextList);
*/
		UpdateIsRead(Id, isRead, bookId)
	}

	async function GetData() {
		const books = await getStudentIdData(slug)
		setBookList(books)
	}

	useEffect(() => {
		GetData()
	}, [profile])

	const isStudent911 = profile?.role === 'Student911'
	return (
		<>
			{!isStudent911 && <STopMenu slug={slug} activeMenu="Booklist" />}
			{isStudent911 && <S911TopMenu slug={slug} activeMenu="Booklist" />}
			<PageNotes type={'Student'} studentId={slug} />
			<div className="col-12">
				<div className="settings-widget">
					<div className="settings-inner-blk p-2">
						<div className="profile-heading p-2">
							<h3>Book List</h3>
						</div>
						<div className="comman-space pb-0">
							<div className="table-responsive">
								{/* Invoice info */}
								<table className="table table-hover mb-0">
									<thead>
										<tr>
											<th>Id</th>
											<th>Title</th>
											<th>Author</th>
											<th>Is Read</th>
										</tr>
									</thead>
									<tbody>
										{booklist.map(function (data) {
											return (
												<tr key={data.bookId}>
													<td>
														<Link to="#" className="invoice-no">
															{data.bookId}
														</Link>
													</td>
													<td>{data.title}</td>
													<td>{data.author}</td>
													<td>
														<div className="form-check form-switch check-on">
															<input
																className="form-check-input"
																type="checkbox"
																checked={data.isRead}
																onChange={(e) => ChangeStatus(data.id, data.isRead, data.bookId)}
															/>
														</div>
													</td>
												</tr>
											)
										})}
									</tbody>
								</table>
								{/* Invoice info */}
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}
